export class SimpleMetric {
    constructor(params) {
        this.value = params.value;
        this.unit = params.unit;
    }
}
